// @core/api/endpoints/landing/install_landing_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InstallLandingTemplateRequest,
  LandingPageResponse,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Install landing template
 * Creates a new landing page from a template. The page is created in draft status.
 */
export async function InstallLandingTemplate(
  template_id: string,
  data: InstallLandingTemplateRequest,
  options?: RequestOptions
): Promise<LandingPageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/templates/:template_id/install`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.post<LandingPageResponse>(requestPath, data, requestOptions);
}
